import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'modifier-input',
  imports: [
    MatSelectModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButton,
  ],
  template: `
    <section class="tw-grid">
      @if( operand ) {
        <mat-form-field>
          <mat-label>Operand Type</mat-label>
          <mat-select [formControl]="fg.controls.type">
            @for(option of operandOptions; track $index) {
              <mat-option [value]="option.value">{{option.label}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      <mat-form-field>
        <mat-label>Base Type</mat-label>
        <mat-select [formControl]="fg.controls.base">
          @for(option of baseOptions; track $index) {
            <mat-option [value]="option.value">{{option.label}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Value</mat-label>
        <input matInput [formControl]="fg.controls.value" />
      </mat-form-field>

      @if( fg.controls.operand ) {
        <modifier-input [fg]="fg.controls.operand" [operand]="true" />
      } @else {
        <button mat-stroked-button (click)="addOperand()">Add Operand</button>
      }

    </section>
  `,
})
export class ModifierInputComponent implements OnInit {

  baseOptions = [
    {
      value: 'inputParams',
      label: 'Input Params',
    },
    {
      value: 'cache',
      label: 'Cache',
    },
    {
      value: 'originalInputData',
      label: 'Original Input Data',
    },
    {
      value: 'aggregate',
      label: 'Aggregate Value',
    },
    {
      value: 'rawValue',
      label: 'Raw Value',
    },
    {
      value: 'constant',
      label: 'Named Constant Value',
    },
    {
      value: 'modelGetter',
      label: 'Model Getter',
    },
    {
      value: 'fromValueSet',
      label: 'From Value Set',
    },
  ];

  operandOptions = [
    {
      value: null,
      label: 'None',
    },
    {
      value: 'add',
      label: 'Add',
    },
    {
      value: 'divide',
      label: 'Divide',
    },
    {
      value: 'multiply',
      label: 'Multiply',
    },
    {
      value: 'power',
      label: 'Power',
    },
    {
      value: 'subtract',
      label: 'Subtract',
    },
  ];


  @Input() fg: FormGroup;

  @Input() operand: boolean = false;

  ngOnInit() {
    if(this.operand) {
      this.fg.addControl('type', new FormControl());
    }
  }

  addOperand() {
    this.fg.addControl('operand', new FormGroup({
      base: new FormControl('inputParams', Validators.required),  // Assuming base is a string
      value: new FormControl('attributesMap.'),
    }));
  }
}
